import React from 'react';
import style from './ParishCard.module.scss';
import { Grabber } from '../Grabber/Grabber';

type ParishCardProps = {
  logo?: string | null;
  active?: boolean;
  name?: string | null;
  address?: string | null;
  onClick?: () => void;
};

export const ParishCard: React.FC<ParishCardProps> = (props) => {
  const { active, logo, name, address, onClick } = props;
  return (
    <div className={`${style.container} ${active ? style.active : ''}`} onClick={onClick}>
      <div className="flex gap-2 items-center p-4">
        {logo ? (
          <img width={60} height={60} src={logo} className="min-w-[60px] bg-emerald-100 rounded-full" />
        ) : (
          <span className="w-[60px] h-[60px] min-w-[60px] bg-emerald-100 rounded-full flex items-center justify-center">
            <i className="fa-solid fa-church" style={{ fontSize: '30px' }} />
          </span>
        )}

        <div className="flex flex-col items-start gap-1">
          <p className="font-inter font-bold ">{name ?? '--'}</p>
          <small className="font-inter text-gray-500 text-start">{address ?? '---'}</small>
        </div>
      </div>
    </div>
  );
};
